import { gql } from '@zenbusiness/application-commons-graphql';

export const CLICKED_FOR_MERCHANT_ACCOUNT_MUTATION = gql`
  mutation markClickedMerchantAccountCTA($input: MerchantAccountInput!) {
    markClickedMerchantAccountCTA(input: $input) {
      success
    }
  }
`;

export const DISMISS_MERCHANT_ACCOUNT_MODAL_MUTATION = gql`
  mutation markDismissedMerchantAccountModal($input: MerchantAccountInput!) {
    markDismissedMerchantAccountModal(input: $input) {
      success
    }
  }
`;
